import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { useState } from "react";
import Fade from "@mui/material/Fade";
import { CircularProgress, Typography } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export const ImagePopup = ({ openDialog, handleConfirmDialog, imageData,Categories }) => {
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleClose = () => {
    setImageLoading(false);
    handleConfirmDialog();
  };
  let attributes = null;
  if (imageData?.data?.attributes !== "null") {
    attributes = JSON.parse(imageData?.data?.attributes);
  }
  const color = attributes?.color;
  const size = attributes?.size;
  let productImage = null;
  if (imageData?.data?.images !== "NA") {
    productImage = JSON.parse(imageData?.data?.images);
  }
  const categoryName=Categories?.find(i=>i?.id===imageData?.data?.category_id)?.name || ""

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleConfirmDialog}>
                Open dialog
            </Button> */}
      <BootstrapDialog
        onClose={handleConfirmDialog}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, fontSize: "16px", width: "600px" }}
          id="customized-dialog-title"
        >
          {imageData?.name}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers style={{ height: "433px", width: "600px" }}>
          <div style={{ height: "55vh" }}>
            {imageLoading && (
              <Box
                sx={{
                  margin: "auto",
                  height: "100%",
                  top: "50%",
                  left: "50%",
                  position: "fixed",
                }}
              >
                <Fade
                  in={imageLoading}
                  style={{
                    transitionDelay: imageLoading ? "800ms" : "0ms",
                  }}
                  unmountOnExit
                >
                  <CircularProgress />
                </Fade>
              </Box>
            )}
            <img
              src={imageData?.img_thumbs}
              alt=""
              style={{ margin: "auto", height: "100%" }}
              onLoad={handleImageLoad}
            />
          </div>
            <Typography style={{width:'100%',textAlign:'center'}}>
                <div>Category: {categoryName}</div>
                <div>Color: {color}</div>
                <div>Type: {size}</div>
            </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
